import { createAction, props } from '@ngrx/store';
import { DateOfStay } from '../../../objects/date-of-stay';

/**
 * Set date of stay action
 */
export const setDateOfStay = createAction(
  '[DateOfStay] Set DateOfStay',
  props<{ dateOfStay: DateOfStay | null}>(),
);
